import { createElementBlock as t, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
};
function c(l, e) {
  return o(), t("svg", r, [...e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      d: "M8 4C5.807 4 4 5.807 4 8v16c0 2.193 1.807 4 4 4h16c2.193 0 4-1.807 4-4V8c0-2.193-1.807-4-4-4zm8 5.333h2.667c0 1.34 1.961 2.667 2.666 2.667v2.667c-.806 0-1.776-.355-2.666-.953v4.953c0 2.205-1.795 4-4 4s-4-1.795-4-4 1.794-4 4-4v2.666a1.335 1.335 0 0 0 0 2.667c.736 0 1.333-.599 1.333-1.333z"
    }, null, -1)
  ])]);
}
const i = { render: c };
export {
  i as default,
  c as render
};
